<template>
  <section class="section -no-pad -over">
    <div class="section-quote" v-reveal>
      <div class="section-quote__content">
        <div class="section-quote__quote">{{ quote }}</div>
        <div class="section-quote__author">{{ author }}</div>
      </div>

      <SwiperImage :images="images" v-reveal="{ delay: 200 }" />
    </div>
    <div
      class="section-quote__accent"
      :style="{ backgroundImage: 'url(/images/LFLS_Physique-Accent.svg)' }"
    />
  </section>
</template>

<script>
import SwiperImage from '@/components/SwiperImage.vue'

export default {
  name: 'SectionQuote',
  components: { SwiperImage },
  props: {
    quote: {
      type: String,
      default: 'Lorem ipsum',
    },
    author: {
      type: String,
      default: 'Author',
    },
    images: {
      type: Array,
      default: () => ['https://placehold.co/1920x1080', 'https://placehold.co/1919x1079'],
    },
  },
}
</script>
